/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：792
 */

"use strict"

var r = require(/* 0 */"react")
var i = r.createContext({})
exports.a = i
